import { render, staticRenderFns } from "./dialog-sets-lock-temporarys.vue?vue&type=template&id=6c0f0d09&scoped=true&"
import script from "./dialog-sets-lock-temporarys.vue?vue&type=script&lang=js&"
export * from "./dialog-sets-lock-temporarys.vue?vue&type=script&lang=js&"
import style0 from "./dialog-sets-lock-temporarys.vue?vue&type=style&index=0&id=6c0f0d09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0f0d09",
  null
  
)

export default component.exports